<script>
import dynamicCollectionItemClass from '@/options/mixins/dynamic-collection-item-class';

export default {
    name: 'dynamic-collection-item-gutter',
    mixins: [dynamicCollectionItemClass],

    data() {
        return {
            displayName: 'Item Gutter',
            tailwindDefinitionProp: 'padding',
            defaultUnit: '0',
        };
    },
};
</script>
